import { computed, makeObservable } from 'mobx'

import asyncAction from 'modules/core/lib/asyncAction'
import { Collection } from 'modules/core/lib/mobx-rest'

import { TYPES } from 'modules/billing/lib/types'
import SubscriptionAddon from 'modules/billing/store/models/SubscriptionAddon'

export const JOB_BOARD_INTEGRATIONS = [
  'indeed',
  'linkedin',
  'linkedin_limited_listings',
  'ats_whatsapp',
]

interface BulkActivateProps {
  apps: string[]
  successFlash?: boolean
  errorFlash?: boolean
}

class SubscriptionAddons extends Collection<SubscriptionAddon> {
  constructor(data = []) {
    super(data)
    makeObservable(this, {
      apps: computed,
      integrations: computed,
    })
  }

  model() {
    return SubscriptionAddon
  }

  get apps(): SubscriptionAddon[] {
    return this.models.filter((model) => {
      return [TYPES.app, TYPES.app_integration].includes(model.type)
    })
  }

  get integrations(): SubscriptionAddon[] {
    return this.models.filter((model) => {
      return model.type == TYPES.integration
    })
  }

  async bulkActivate({ apps, successFlash, errorFlash }: BulkActivateProps) {
    return await asyncAction(
      () =>
        this.rpc('bulk_activate', {
          apps: apps,
        }),
      {
        successFlash: !!successFlash,
        errorFlash: !!errorFlash,
      }
    )
  }
}

const singleton: SubscriptionAddons = new SubscriptionAddons()

export default singleton
